<template>
    <div class="pb-5 sm:pb-0">
        <nav class="flex" aria-label="Breadcrumb">
            <ol class="flex items-center space-x-1">
                <li>
                    <div>
                        <router-link
                            :to="{ name: 'AdminProjectsScreen' }"
                            class="text-sm font-medium text-taupe-500 hover:text-taupe-800"
                        >
                            Admin
                        </router-link>
                    </div>
                </li>

                <li>
                    <div class="flex items-center">
                        <zen-icon-chevron-right
                            css-classes="h-5 w-5 shrink-0 text-taupe-500"
                        />
                        <router-link
                            :to="{ name: 'AdminProjectsScreen' }"
                            class="ml-1 text-sm font-medium text-taupe-500 hover:text-taupe-800"
                        >
                            Projects
                        </router-link>
                    </div>
                </li>
            </ol>
        </nav>
        <h1 class="text-3xl font-semibold text-taupe-900">{{ project }}</h1>
        <div class="mt-4 sm:mt-5">
            <!-- Dropdown menu on small screens -->
            <div class="sm:hidden">
                <label for="current-tab" class="sr-only">Select a tab</label>
                <select
                    id="current-tab"
                    @change="navigate"
                    name="current-tab"
                    class="block w-full rounded-md border-taupe-300 py-2 pl-3 pr-10 text-base focus:border-sky-500 focus:outline-hidden focus:ring-sky-500 sm:text-sm"
                >
                    <option
                        :selected="isEnvironments"
                        value="AdminProjectsSingleEnvironmentsScreen"
                    >
                        Environments
                    </option>
                    <option
                        v-if="can(PERMISSIONS.PROJECT_UPDATE)"
                        :selected="isSettings"
                        value="AdminProjectsSingleSettingsScreen"
                    >
                        Settings
                    </option>
                </select>
            </div>
            <!-- Tabs at small breakpoint and up -->
            <div class="hidden sm:block">
                <zen-tab-list>
                    <zen-tab
                        :active="isEnvironments"
                        :to="{
                            name: 'AdminProjectsSingleEnvironmentsScreen',
                            params: { projectKey: projectKey },
                        }"
                    >
                        Environments
                    </zen-tab>
                    <zen-tab
                        v-if="can(PERMISSIONS.PROJECT_UPDATE)"
                        :active="isSettings"
                        :to="{
                            name: 'AdminProjectsSingleSettingsScreen',
                            params: { projectKey: projectKey },
                        }"
                    >
                        Settings
                    </zen-tab>
                </zen-tab-list>
            </div>
        </div>
    </div>
</template>

<script>
import { usePermissions, PERMISSIONS } from '@/composables/usePermissions'

export default {
    name: 'ProjectHeaderTabs',
    setup() {
        const { can } = usePermissions()
        return { can, PERMISSIONS }
    },
    computed: {
        isEnvironments() {
            return this.current == 'environments'
        },
        isSettings() {
            return this.current == 'settings'
        },
    },
    methods: {
        async navigate(e) {
            await this.$router.push({
                name: e.target.value,
                params: { projectKey: this.projectKey },
            })
        },
    },
    props: ['current', 'project', 'projectKey'],
}
</script>
